@if (!loading) {
  <div class="flex flex-col justify-start sidenav-body">
    @if (developers?.length) {
      <div class="table-container">
        <tree-display
          [treeData]="treeData"
          [expandable]="true"
          [showSearch]="true"
          [showControls]="false"
          [allowSelectAllResults]="false"
          [allowDeselectAll]="false"
          [cascadeSelect]="false"
          [expandAll]="false"
          [selectedNodes]="selectedNodes"
          [searchString]="filterValue"
          [maxSelections]="maxSelections"
          [typeIdentifier]="disabledNodeAttribute"
          [labelIdentifier]="labelIdentifier"
          [iconIdentifier]="iconIdentifier"
          [disabledNodeDefinitions]="disabledNodeDefinitions"
          [searchProperties]="searchProperties"
          [multiSelect]="false"
          (expansion$)="expansionHandler($event)"
          (selection$)="selectionHandler($event)"
          (clicked$)="clickedHandler($event)"
        ></tree-display>
      </div>
    }
    @if (!loading && !developers?.length) {
      <div class="list-empty">
        {{ 'sidenav.list.none_configured' | translate }}
      </div>
    }
  </div>
}

@if (loading) {
  <div class="spinner-container">
    <mat-spinner mode="indeterminate" diameter="60"></mat-spinner>
  </div>
}
